import classNames from 'classnames';
import React from 'react';

import './Message.scss';

interface Props {
    children: JSX.Element | string;
    type?: 'info' | 'success' | 'warning';
}

const InfoBox = ({ children, type }: Props): JSX.Element => (
    <div className={classNames('ekb-info-box', type)}>{children}</div>
);

export default InfoBox;
